<template>
    <div class="industry-add-or-update">
        <el-dialog
            :title="industries.id == 0 ? '新增' : '修改'"
            :close-on-click-modal="false"
            :visible.sync="visible"
            @close="industryClose"
        >
            <el-form
                :inline="true"
                ref="industriesRef"
                :model="industries"
                :rules="industriesRules"
                label-width="100px"
                @keyup.enter.native="industrySubmit()"
            >
                <el-form-item
                    label="产业园名称"
                    prop="industrialName"
                    class="form-item-width"
                >
                    <el-input
                        v-model="industries.industrialName"
                        placeholder="请输入产业园区名称"
                    ></el-input>
                </el-form-item>
                <el-form-item label="产业园地址" prop="address">
                    <el-input
                        v-model="industries.address"
                        placeholder="请输入产业园地址"
                    ></el-input>
                </el-form-item>
                <el-form-item label="联系人" prop="concatPeople">
                    <el-input
                        class="input-style"
                        v-model="industries.concatPeople"
                        placeholder="请输入联系人"
                    ></el-input>
                </el-form-item>
                <el-form-item label="联系电话" prop="phone">
                    <el-input
                        class="input-style"
                        v-model="industries.phone"
                        placeholder="请输入联系电话"
                    ></el-input>
                </el-form-item>
                <el-form-item label="产业园面积" prop="areas">
                    <el-input
                        class="input-style"
                        v-model="industries.areas"
                        placeholder="请输入产业园面积"
                    ></el-input>
                </el-form-item>
                <el-form-item label="产业园类型" prop="type">
                    <el-select
                        v-model="industries.type"
                        width="100"
                        clearable
                        placeholder="请输入产业园类型"
                    >
                        <el-option label="国家级电商产业园区" value="1">
                        </el-option>
                        <el-option label="省级电商产业园区" value="2">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="年度" prop="annual">
                    <el-date-picker
                        v-model="industries.annual"
                        type="year"
                        value-format="yyyy"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="城市地区" prop="cityCode">
                    <el-select
                        v-model="industries.cityCode"
                        width="100"
                        clearable
                        placeholder="请选择城市"
                    >
                        <el-option
                            v-for="item in codeListArr"
                            :key="item.id"
                            :label="item.areaName"
                            :value="item.code"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="配置" class="textarea-style">
                    <el-input
                        type="textarea"
                        :rows="2"
                        placeholder="请输入内容"
                        v-model="industries.matching"
                    >
                    </el-input>
                </el-form-item>
                <el-form-item label="条件" class="textarea-style">
                    <el-input
                        type="textarea"
                        :rows="2"
                        placeholder="请输入内容"
                        v-model="industries.qualification"
                    >
                    </el-input>
                </el-form-item>
                <el-form-item label="服务" prop="service">
                    <el-button
                        type="info"
                        icon="el-icon-edit"
                        size="small"
                        @click="openRichDialog('service')"
                        >前往编写活服务内容</el-button
                    >
                </el-form-item>
                <el-form-item label="优势" prop="service">
                    <el-button
                        type="info"
                        icon="el-icon-edit"
                        size="small"
                        @click="openRichDialog('advantage')"
                        >前往编写优势内容</el-button
                    >
                </el-form-item>
                <el-form-item label="活动图片" prop="thumb">
                    <el-upload
                        class="upload"
                        ref="upload"
                        :action="uploadUrl"
                        name="file"
                        :limit="1"
                        accept=".png,.jpg"
                        :on-remove="handleRemove"
                        :before-upload="beforeUpload"
                        :on-success="handleSuccess"
                        :file-list="fileList"
                        list-type="picture"
                    >
                        <el-button slot="trigger" size="small" type="primary"
                            >选取文件</el-button
                        >

                        <div slot="tip" class="el-upload__tip">
                            只能上传 .png .jpg图片，且不超过10MB
                        </div>
                    </el-upload>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="industrySubmit"
                    >提交</el-button
                >
                <el-button @click="visible = false">取消</el-button>
            </span>

            <!-- 内层对话框 -->
            <el-dialog
                width="50%"
                :title="editorType === 'service' ? '服务内容' : '优势内容'"
                :visible.sync="industryVisible"
                append-to-body
                @closed="closeHandle"
            >
                <div id="demo1"></div>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="industryVisible = false"
                        >确 定</el-button
                    >
                </span>
            </el-dialog>
        </el-dialog>
    </div>
</template>

<script>
import getCityCode from "@/utils/cityCode.js";
import IndustryRichEditor from "@/views/modules/config/child-components/industry-rich-editor";
// 引入 wangEditor
import wangEditor from "wangeditor";
// 引入过滤函数
import { showcontent } from "@/utils/method.js";
export default {
    components: {
        IndustryRichEditor,
    },
    data() {
        return {
            visible: false,
            // 新增/修改产业园
            industries: {
                id: null,
                industrialName: "",
                concatPeople: "",
                cityCode: "",
                matching: "",
                annual: "",
                type: "",
                qualification: "",
                areas: "",
                phone: "",
                thumb: "",
                address: "",
                service: "",
                advantage: "",
            },
            uploadUrl: "",
            fileList: [],
            industryVisible: false,
            editor: null,
            // 表单校验规则
            industriesRules: {
                industrialName: [
                    {
                        required: true,
                        message: "请输入产业园区名称",
                        trigger: "blur",
                    },
                ],
                address: [
                    {
                        required: true,
                        message: "请输入产业园区地址",
                        trigger: "blur",
                    },
                ],
                cityCode: [
                    {
                        required: true,
                        message: "请输入城市地区",
                        trigger: "change",
                    },
                ],
                annual: [
                    {
                        required: true,
                        message: "请选择某一年度",
                        trigger: "change",
                    },
                ],
                 phone: [
                    {
                        required: true,
                        message: "请填写电话",
                        trigger: "blur",
                    },
                ],
                 concatPeople: [
                    {
                        required: true,
                        message: "请填写联系人",
                        trigger: "blur",
                    },
                ],
                 thumb: [
                    {
                        required: true,
                        message: "请选择图片",
                        trigger: "blur",
                    },
                ],
                 type: [
                    {
                        required: true,
                        message: "请选择产业园类型",
                        trigger: "blur",
                    },
                ],
            },
            // 城市编码对象数组
            codeListArr: [],
            // 判断打开的富文本是哪个
            editorType: "",
            // 存放富文本内容
            editorContent: "",
        };
    },
    created() {
        getCityCode().then((data) => {
            this.codeListArr = data[1];
        });
        this.uploadUrl = 'https://activity.suhoo.net/api/upload/image';
    },
    methods: {
        init(id) {
            this.industries.id = id || 0;
            this.visible = true;
            // 传入有id的时候获取这条数据展示在表单上
            if (this.industries.id) {
                this.$ajaxPost("/industrialPark/list", { id }).then(
                    ({ data }) => {
                        if (data.code === 0) {
                            Object.keys(this.industries).forEach((item) => {
                                if (
                                    item === "service" ||
                                    item === "advantage"
                                ) {
                                    this.industries[item] = showcontent(showcontent(showcontent(
                                        data.data.list[0][item]
                                    )))
                                } else if(item === 'annual') {
                                    // 返回来的annual格式为xxxx,xxxx
                                    let yearArr = data.data.list[0][item].split(',');
                                    this.industries[item] = yearArr[yearArr.length - 1];
                                } else {
                                    this.industries[item] =
                                        data.data.list[0][item];
                                }
                            });
                            // 将图片展示
                            if (this.industries.thumb) {
                                const obj = {
                                    url: this.industries.thumb,
                                };
                                this.fileList = [obj];
                            }
                        }
                    }
                );
            }
        },
        // 点击提交按钮触发
        industrySubmit() {
            this.$refs["industriesRef"].validate((valid) => {
                if (valid) {
                    let industries = {}
                    // 添加产业园时不能传id
                    industries = {...this.industries}
                    if(this.industries.id === 0) {
                        delete industries.id
                        industries.showStatus = '0'
                    }
                    
                    industries.annual =
                        parseInt(industries.annual) -
                        1 +
                        "," +
                        industries.annual;
                    this.$ajaxPost(
                        `/industrialPark/${
                            this.industries.id ? "update" : "save"
                        }`,
                        industries
                    ).then(({ data }) => {
                        if (data.code === 0) {
                            this.visible = false;
                            this.$message.success(`${this.industries.id ? '更新成功!' : '添加成功!'}`)
                            this.$emit("optionSuccess");
                        }
                    });
                }
            });
        },
        // 关闭添加/修改对话框时的事件
        industryClose() {
            this.fileList = [];
            this.$refs.industriesRef.resetFields();
            Object.keys(this.industries).forEach((item) => {
                if (item === "id") {
                    this.industries[item] = null;
                } else {
                    this.industries[item] = "";
                }
            });
        },
        // 从本地保存的上传目录中删除图片路径
        handleRemove() {
            this.industries.thumb = "";
        },
        // 打开富文本对话框
        openRichDialog(value) {
            this.industryVisible = true;
            this.editorType = value;

            this.editorContent = this.industries[value];
            if (this.editor) {
                this.editor.txt.html(this.editorContent);
            }
            if (!this.editor) {
                this.$nextTick(() => {
                    // this.$refs.editorRef.init(value);
                    const editor = new wangEditor("#demo1");
                    // 配置 onchange 回调函数，将数据同步到 vue 中
                    editor.config.onchange = (newHtml) => {
                        this.editorContent = newHtml;
                    };
                    editor.config.showLinkImg = false;
                    editor.config.uploadFileName = "file";
                    editor.config.uploadImgServer = this.uploadUrl;
                    /* editor.config.customUploadImg = function (
                        resultFiles,
                        insertImgFn
                    ) {
                        let objectURL = URL.createObjectURL(resultFiles[0]);
                        insertImgFn(objectURL);
                    }; */
                    editor.config.uploadImgHooks = {
                        customInsert: function (insertImg, result, editor) {
							let url = (result.data.fileInfo.domain ? result.data.fileInfo.domain+'/' : 'https://activity.suhoo.net/')+result.data.fileInfo.file_path;
							insertImg(url);
                        }
                    }
                    editor.create();
                    editor.txt.html(this.editorContent);
                    this.editor = editor;
                });
            }
        },
        // 关闭富文本对话框时的回调
        closeHandle() {
            if (this.editorType === "service") {
                this.industries.service = this.editorContent;
            } else {
                this.industries.advantage = this.editorContent;
            }
            this.editor.txt.clear();
            if(this.editor){
                this.editor.destroy()
                this.editor = null
            }
            
        },
        beforeUpload(file) {
            const isLt100M = file.size / 1024 / 1024 < 10;
            if (!isLt100M) {
                this.$message.error("上传文件大小不能超过 10MB!");
            }
            return isLt100M;
        },
        handleSuccess(response) {
            if (response && response.code === 0) {
                console.log(response);
                console.log("文件上传成功返回结果：", response.data);
				let url = (response.data.fileInfo.domain ? response.data.fileInfo.domain+'/' : 'https://activity.suhoo.net/')+response.data.fileInfo.file_path;
                this.industries.thumb = url;
            }
        },
    },
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog__body {
    .el-form-item {
        margin-bottom: 10px;
        width: 48%;
    }
}
/deep/ .el-form-item__error {
    padding-top: 0;
}
/deep/ .el-upload-list--picture {
    .el-upload-list__item {
        width: 92px;
        height: 92px;
    }
}
.textarea-style {
    padding-top: 5px;
}
</style>